
export default {
    name: "popup_leaderboard",
    props: ["item"],
    data(){
        return {
            isLoading: true,

            tabs: ["solo", "group", "prizes"],
            selectedTab: "solo",

            myItem: null,
            leaderboardLimit: 500,
            leaderboardItems: [],

            selectedLang: "en",
            langText: {
                en: {
                    solo: "Solo",
                    group: "Group",
                    prizes: "Prizes and Scoring",
                    prize_title: "PRIZES AND SCORING MECHANICS",
                    prize_desc_1: "There are more ways to win than ever before!",  
                    prize_desc_2: "Make sure to get your friends on board; not only will the top 1,500 participants be rewarded, there are Group and referral-based prizes to be won as well.",
                    view_leaderboard: "VIEW LEADERBOARDS",
                },
                cn: {
                    prize_title: "奖励和计分机制",
                    prize_desc_1: "今年您将有更多机会赢取奖励！",  
                    prize_desc_2: "快叫上您的好友一起参加吧！除了前1500名的参与者能够获得奖励之外，还有团队和推荐相关的奖励等着您哦！",
                    view_leaderboard: "查看排行榜",
                },
            },
        }
    },
    computed: {
        
    },
    mounted(){
        this.onFetchItems();
    },
    methods: {
        onSelectTab(item){
            this.selectedTab = item;
            if(item == "solo") this.onFetchItems();
            this.onHandleTriggerAnalytics(`open@${ item }@leaderboard`);
        },
        onFetchItems(){
            this.isLoading = true;
            this.$axios.$get(`/stamp/leaderboard?limit=${ this.leaderboardLimit }`, this.tokenHeader).then((res) => {
                console.log("leaderboardCallback", res);
                this.leaderboardItems = res.items;     
                this.myItem = res.myItem;
                this.isLoading = false;
            }).catch((err) => {
                console.error("leaderboardError", err);
                return this.onHandleApiError(err);
            });
        },
        onClickCloseBtn(){
            this.$emit("update:currentPopupItem", null);
            this.onHandleTriggerAnalytics(`close@leaderboard`);
        },
    },
    watch: {
        
    }
}
